import { err, ok } from 'neverthrow';
import { Ty } from '../../../ty';
import { isAllowedCast } from '../allowed-cast';
import { FunctionTypingRule } from '../function-call';
import { Errs } from '../../type-checker';

export const formatTypingRule: FunctionTypingRule = (_op, args) => {
  const to = Ty.ty('string').ty;

  for (const arg of args) {
    const from = arg.ty;
    if (!isAllowedCast({ from, to })) {
      return err(new Errs.IllegalCast({ from, to }));
    }
  }

  const outputTy: Ty.ExtendedAttributeType = {
    ty: { k: 'primitive', t: 'string' },
    nullable: false,
    tags: [],
  };

  return ok(outputTy);
};

export const formatNullableTypingRule: FunctionTypingRule = (_op, args) => {
  const to = Ty.ty('string').ty;

  for (const arg of args) {
    const from = arg.ty;
    if (!isAllowedCast({ from, to })) {
      return err(new Errs.IllegalCast({ from, to }));
    }
  }

  const outputTy: Ty.ExtendedAttributeType = {
    ty: { k: 'primitive', t: 'string' },
    nullable: args.some((arg) => arg.nullable),
    tags: [],
  };

  return ok(outputTy);
};
